import React from 'react'
import { SidebarContainer, Icon, CloseIcon,NavSocialItem, SidebarWrapper, SidebarMenu, SidebarLink, SidebarRoute, SideBtnWrap } from './SidebarElements'

const Sidebar = ({isOpen,toggle}) => {
  return (
    <SidebarContainer isOpen={isOpen} onClick={toggle}>
      <Icon onClick={toggle}>
        <CloseIcon />
      </Icon>
      <SidebarWrapper>
        <SidebarMenu>
          <SidebarLink to='about' onClick={toggle}>About us</SidebarLink>
          <SidebarLink to='roadmap' onClick={toggle}>Roadmap</SidebarLink>
          <SidebarLink to='staff' onClick={toggle}>Staff</SidebarLink>
        </SidebarMenu>
        <SideBtnWrap>
          <SidebarRoute to='/minting'>Let's Grow!</SidebarRoute>
        </SideBtnWrap>
      </SidebarWrapper>
    </SidebarContainer>
  )
}

export default Sidebar
